const styles = theme => ({
  grow: {
    flexGrow: 1,
  },
  toolbar: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    zIndex: 1,
  },
  rootContainer: {
    padding: theme.spacing(4),
    backgroundColor: '#f8fafc',
    minHeight: 'calc(100vh - 64px)',
  },
  card: {
    padding: theme.spacing(3),
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
    border: '1px solid #e2e8f0',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
    },
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  iconWrapper: {
    background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
    color: '#3b82f6',
    width: '44px',
    height: '44px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    boxShadow: '0 4px 10px rgba(59, 130, 246, 0.1)',
  },
  title: {
    fontWeight: 700,
    color: '#1e293b',
  },
  statusBadge: {
    fontSize: '0.7rem',
    fontWeight: 700,
    padding: '4px 12px',
    borderRadius: '20px',
    display: 'inline-flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
    textTransform: 'uppercase',
    letterSpacing: '0.025em',
  },
  statusUploaded: {
    backgroundColor: '#dcfce7',
    color: '#15803d',
  },
  statusEmpty: {
    backgroundColor: '#f1f5f9',
    color: '#64748b',
  },
  unpublishedOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    zIndex: 1,
    pointerEvents: 'none',
    borderRadius: '16px',
    transition: 'all 0.3s ease',
  },
  cardInner: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  uploadArea: {
    marginTop: 'auto',
    padding: theme.spacing(2),
    border: '2px dashed #e2e8f0',
    borderRadius: '12px',
    textAlign: 'center',
    transition: 'border-color 0.2s ease',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  filename: {
    fontSize: '0.75rem',
    color: '#64748b',
    fontFamily: 'var(--font-mono, monospace)',
    wordBreak: 'break-all',
    marginBottom: theme.spacing(2),
    backgroundColor: '#f8fafc',
    padding: '6px 10px',
    borderRadius: '8px',
    border: '1px solid #f1f5f9',
  },
  metadata: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '0.75rem',
    color: '#94a3b8',
    marginBottom: theme.spacing(2.5),
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 'auto',
    paddingTop: theme.spacing(2),
    borderTop: '1px solid #f1f5f9',
  },
  actionButton: {
    width: '100%',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.8rem',
    padding: '6px 16px',
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'center',
  },
  saveButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(6),
  },
  saveButton: {
    borderRadius: '30px',
    padding: '12px 40px',
    fontWeight: 700,
    boxShadow: '0 4px 15px rgba(237, 108, 2, 0.3)',
    textTransform: 'none',
    fontSize: '1rem',
  }
});

export default styles;
